module.exports = __webpack_public_path__ + "media/images/parallax/illustration-be-middleground-04266d01a0412a706f956ed47f441b07.png";